export const shufflePlanChartData = [
  { name: "Private Sale1", value: 1000000000, fill: "#FF7CFF" },
  { name: "Private Sale2", value: 1000000000, fill: "#FF3AC1" },
  { name: "Team", value: 500000000, fill: "#3A7FFF" },
  { name: "Marketing", value: 819730547, fill: "#2A0085" },
  { name: "Current Holders", value: 1615547440, fill: "#793AFF" },
  { name: "Inflation Reward", value: 3000000000, fill: "#64CFF6" },
  { name: "Company", value: 2064722013, fill: "#CDB5FF" },
];
export const pricePlanChartData = [
  { name: "Staking Reward", value: 85000000, fill: "#FF7CFF" },
  { name: "Marketing", value: 10000000, fill: "#64CFF6" },
  { name: "Team", value: 5000000, fill: "#793AFF" },
];
